import { makeNavLink } from "./navbar";

export default function injectFooter() {
    try {
        let footer = document.querySelector('#ep-footer');
    
        let footerLogo = document.createElement('div');
        footerLogo.id = 'footer-logo';
        footerLogo.innerHTML = `
            <img src="https://cc.sj-cdn.net/instructor/1i94b7non60nr-clickup-university/themes/3dfijq5kqzyuf/header-logo.1636392712.png" alt="ClickUp University">
        `;
    
        let footerNavBar = document.createElement('ul');
    
        footerNavBar.append(makeNavLink({
            link: '/page/course-catalog',
            text: 'All Courses',
            target: ''
        }));
        
        footerNavBar.append(makeNavLink({
            link: 'https://clickup.com/webinar',
            text: 'Webinars',
            target: '_blank'
        }));
    
        footerNavBar.append(makeNavLink({
            link: 'https://clickup.com/blog/',
            text: 'Blog',
            target: '_blank'
        }));
    
        let userEmail = '';
        if (typeof skilljarUser !== 'undefined') {
            userEmail = skilljarUser.email;
        }
    
        footerNavBar.append(makeNavLink({
            link: 'https://clickup.qualtrics.com/jfe/form/SV_1SnfB1JqCjwzdbM?studentEmail=' + userEmail,
            text: 'Give Feedback',
            target: '_blank'
        }));
    
        footer.appendChild(footerLogo);
        footer.appendChild(footerNavBar);
    } catch (e) {
        console.warn("Footer Error", e);
    }
};
